import { API_URL } from '@dynameat/constants/api';

// Power BI params

export const POWER_BI_PARAMS = (pointOfSaleGuid = '') => `${API_URL()}/${process.env.VUE_APP_POWER_BI_PARAMS}/${pointOfSaleGuid}`;
